import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { detalheEmpresaSeller, editarSeller } from '../../../services/http/sellerService';
import { trackPromise } from 'react-promise-tracker';
import services from '../../../services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { estados, cidadesBrasil } from '../../../services/estadosBrasil'
import { buscarEnderecoPorCep } from '../../../services/http/cepService';
import { useSnackBar } from '../../../hooks/snackBar';

import './styles.scss';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250
        }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

const PerfilDadosCadastraisSeller = () => {
    const history = useHistory();
    const { addSnackBar } = useSnackBar();
    const [isFormInvalid, setIsFormInvalid] = useState(false);
    const [idEmpresa, setIdEmpresa] = useState(null);
    const [empresaSeller, setEmpresaSeller] = useState({
        cnpj: "",
        ie: "",
        razaoSocial: "",
        nomeFantasia: "",
        tipo: "",
        ativo: false,
        endereco: {
            id: "",
            cep: "",
            logradouro: "",
            numero: "",
            complemento: "",
            bairro: "",
            cidade: "",
            estado: "",
            urlGoogleMaps: ""
        },
        telefone: {
            id: "",
            ddd: "",
            numero: ""
        }
    });

    const [cidades, setCidades] = useState([]);

    useEffect(() => {
        CarregarDetalhesEmpresaSeller();
    }, []);

    const CarregarDetalhesEmpresaSeller = () => {
        const { idSeller } = services.storage.getUser();

        console.log(idSeller);

        if (!idSeller) {
            addSnackBar({
                message: 'Erro ao tentar buscar os dados do Seller',
                info: 'error',
                open: true
            });

            history.push('/home');
        }

        trackPromise(
            detalheEmpresaSeller(idSeller)
                .then(res => {
                    if (res.data) {
                        console.log(res.data);
                        setEmpresaSeller(res.data);
                        if (res.data?.endereco?.estado != null) {
                            listarCidadesBrasil(res.data.endereco.estado);
                        } else {
                            setEmpresaSeller((prevent) => ({
                                ...prevent,
                                endereco: {
                                    id: "",
                                    cep: "",
                                    logradouro: "",
                                    numero: "",
                                    complemento: "",
                                    bairro: "",
                                    cidade: "",
                                    estado: "",
                                    urlGoogleMaps: ""
                                }
                            }));
                        }
                        if (res.data?.telefone == null) {
                            setEmpresaSeller((prevent) => ({
                                ...prevent,
                                telefone: {
                                    id: "",
                                    ddd: "",
                                    numero: ""
                                }
                            }));
                        }
                        setIdEmpresa(idSeller);
                    } else {
                        if (idEmpresa) {
                            addSnackBar({ message: 'Não foi possível carregar detalhes do seller', info: 'error', open: true });
                        }
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro ao tentar obter detalhes do seller', info: 'error', open: true });
                })
        )
    }

    const enderecoPorCep = (cep) => {
        trackPromise(
            buscarEnderecoPorCep(cep)
                .then(res => {
                    if (!res.fail && res.data) {
                        listarCidadesBrasil(res.data.uf.sigla);

                        console.log(res.data);

                        setEmpresaSeller((prevent) => ({
                            ...prevent,
                            endereco: {
                                cep: res.data.cep,
                                logradouro: res.data.logradouro,
                                bairro: res.data.bairro,
                                estado: res.data.uf.sigla,
                                cidade: res.data.cidade.nome
                            }
                        }));
                    }
                })
        ).catch(error => {
            console.log(error);
        })
    }

    const listarCidadesBrasil = (uf) => {
        trackPromise(
            cidadesBrasil(uf)
                .then(res => {
                    if (res.data) {
                        setCidades(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar as cidades', info: 'warning', open: true });
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro ao carregar cidades', info: 'error', open: true });
                })
        )
    }

    const validarForm = () => {
        var isInvalidForm = false;
        if (!empresaSeller.cnpj) isInvalidForm = true;
        /* if (!empresaSeller.ie) isInvalidForm = true;
        if (!empresaSeller.im) isInvalidForm = true; */
        if (!empresaSeller.razaoSocial) isInvalidForm = true;
        if (!empresaSeller.nomeFantasia) isInvalidForm = true;
        /*    if (!empresaSeller.endereco.bairro) isInvalidForm = true;
           if (!empresaSeller.endereco.numero) isInvalidForm = true;
           if (!empresaSeller.endereco.cep) isInvalidForm = true;
           if (!empresaSeller.endereco.cidade) isInvalidForm = true;
           if (!empresaSeller.endereco.logradouro) isInvalidForm = true;
           if (!empresaSeller.endereco.urlGoogleMaps) isInvalidForm = true; */

        setIsFormInvalid(isInvalidForm);

        return isInvalidForm;
    }

    const verificarTelefone = () => {
        //alert('Teste a')
        //if (empresaSeller.telefone.numero.includes("(")) {
        //    empresaSeller.telefone.ddd = empresaSeller.telefone.numero.substring(0, 4).replace("(", "").replace(")", "");
        //    empresaSeller.telefone.numero = empresaSeller.telefone.numero.substring(5, empresaSeller.telefone.lenght).replace('-', '');
        //}
        //if (empresaSeller.telefone.numero.length == 11) {
        //    empresaSeller.telefone.numero = empresaSeller.telefone.numero.substring(2, empresaSeller.telefone.numero.length);
        //}
    }

    const submitEmpresaSeller = () => {
        if (!validarForm()) {
            empresaSeller.cnpj = services.mask.unMask(empresaSeller.cnpj)
            empresaSeller.endereco.cep = services.mask.unMask(empresaSeller.endereco.cep)
            verificarTelefone();

            empresaSeller.id = idEmpresa;
            trackPromise(
                editarSeller(empresaSeller)
                    .then(res => {
                        if (res.fail == null) {
                            addSnackBar({ message: 'Seller atualizado com sucesso', info: 'success', open: true });
                            if (empresaSeller.telefone.numero != "" && empresaSeller.telefone.numero.length == 9) {
                                //alert('Teste b')
                                //empresaSeller.telefone.numero = empresaSeller.telefone.ddd + empresaSeller.telefone.numero;
                                setEmpresaSeller((prevent) => ({
                                    ...prevent,
                                    telefone: empresaSeller.telefone
                                }));
                            }
                            history.push('/home');
                        } else {
                            res.errors.forEach(element => {
                                addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                            });
                        }
                    }).catch(error => {
                        console.log(error);
                        addSnackBar({ message: 'Erro ao cadastrar seller', info: 'error', open: true });
                    })
            )

        }
        //alert('Teste k');
        //if (empresaSeller.telefone.numero.length == 9) {
        //    empresaSeller.telefone.numero = empresaSeller.telefone.ddd + empresaSeller.telefone.numero;
        //}
    }

    const changesDadosEmpresa = (value, propertie) => {
        setEmpresaSeller((prevent) => ({
            ...prevent,
            [propertie]: value
        }));
    }

    const changesEndereco = (value, propertie,) => {
        setEmpresaSeller((prevent) => ({
            ...prevent,
            endereco: {
                ...prevent.endereco,
                [propertie]: value
            }
        }));
        if (propertie === 'estado') {
            listarCidadesBrasil(value);
        }

    }

    const changesTelefone = (value) => {
        //var ddd = value.substring(0, 4).replace("(", "").replace(")", "");
        //var numero = value.substring(5,value.lenght).replace('-','');
        var ddd = (value.length >= 2 ? value.substring(0, 4) : value).replace("(", "").replace(")", "");
        var numero = (value.length >= 2 ? value.substring(5, value.length) : '').replace('-', '').replace(' ', '');
        setEmpresaSeller((prevent) => ({
            ...prevent,
            telefone: {
                ...prevent.telefone,
                numero: numero,
                ddd: ddd
            }
        }));
    }

    useEffect(() => {
        //if (empresaSeller?.telefone?.numero != "" && empresaSeller?.telefone?.numero?.length == 9) {
        //    empresaSeller.telefone.numero = empresaSeller.telefone.ddd + empresaSeller.telefone.numero;
        //}
    }, [empresaSeller]);

    return (
        <div>
            <div className='row mt-1 ml-1 titulo'>
                Empresa
            </div>
            <div className='row mt20  ml-1 '>
                <h1 className='label-second'>Dados Empresa</h1>
            </div>
            <div className="row mt20">
                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField
                            required
                            label="CNPJ"
                            placeholder="00000000000000"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesDadosEmpresa(services.mask.cpfCnpj(event.target.value), 'cnpj')}
                            value={services.mask.cpfCnpj(empresaSeller?.cnpj) || ''}
                            helperText={isFormInvalid && !empresaSeller?.cnpj && 'Campo obrigatório'}
                            error={isFormInvalid && !empresaSeller?.cnpj ? true : false}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField
                            label="IE"
                            inputProps={{ maxLength: 30 }}
                            placeholder="000000"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesDadosEmpresa(event.target.value, 'ie')}
                            value={empresaSeller?.ie || ''}
                        /*  helperText={isFormInvalid && !empresaSeller?.ie && 'Campo obrigatório'}
                         error={isFormInvalid && !empresaSeller?.ie ? true : false} */
                        />
                    </FormControl>
                </div>

                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl >
                        <TextField
                            label="IM"
                            inputProps={{ maxLength: 30 }}
                            placeholder="000000"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesDadosEmpresa(event.target.value, 'im')}
                            value={empresaSeller?.im || ''}
                        /*  helperText={isFormInvalid && !empresaSeller?.im && 'Campo obrigatório'}
                         error={isFormInvalid && !empresaSeller?.im ? true : false} */
                        />
                    </FormControl>
                </div>

                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl >
                        <TextField
                            required
                            label="Razão Social"
                            inputProps={{ maxLength: 200 }}
                            placeholder="Informe a Razão Social"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesDadosEmpresa(event.target.value, 'razaoSocial')}
                            value={empresaSeller?.razaoSocial || ''}
                            helperText={isFormInvalid && !empresaSeller?.razaoSocial && 'Campo obrigatório'}
                            error={isFormInvalid && !empresaSeller?.razaoSocial ? true : false}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                        <TextField
                            required
                            label="Nome Fantasia"
                            inputProps={{ maxLength: 150 }}
                            placeholder="Informe o Nome Fantasia"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesDadosEmpresa(event.target.value, 'nomeFantasia')}
                            value={empresaSeller?.nomeFantasia || ''}
                            helperText={isFormInvalid && !empresaSeller?.nomeFantasia && 'Campo obrigatório'}
                            error={isFormInvalid && !empresaSeller?.nomeFantasia ? true : false}
                        />
                    </FormControl>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-2 col-md-2 col-lg-2"><FormControl >
                    <TextField
                        label="CEP"
                        placeholder="00000-000"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onBlur={event => enderecoPorCep(event.target.value)}
                        onChange={event => changesEndereco(services.mask.cep(event.target.value), 'cep')}
                        value={services.mask.cep(empresaSeller?.endereco?.cep) || ''}
                    /* helperText={isFormInvalid && !empresaSeller?.endereco.cep && 'Campo obrigatório'}
                    error={isFormInvalid && !empresaSeller?.endereco.cep ? true : false} */
                    />
                </FormControl></div>
                <div className="col-sm-4 col-md-4 col-lg-4"><FormControl >
                    <TextField
                        label="Logradouro"
                        inputProps={{ maxLength: 150 }}
                        placeholder="Informe o endereço"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'logradouro')}
                        value={empresaSeller?.endereco?.logradouro || ''}
                    /* helperText={isFormInvalid && !empresaSeller?.endereco.logradouro && 'Campo obrigatório'}
                    error={isFormInvalid && !empresaSeller?.endereco.logradouro ? true : false} */
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2"><FormControl >
                    <TextField
                        label="Número"
                        inputProps={{ maxLength: 10 }}
                        placeholder="000000"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'numero')}
                        value={empresaSeller?.endereco?.numero || ''}
                    /* helperText={isFormInvalid && !empresaSeller?.endereco.numero && 'Campo obrigatório'}
                    error={isFormInvalid && !empresaSeller?.endereco.numero ? true : false} */
                    />
                </FormControl></div>
                <div className="col-sm-4 col-md-4 col-lg-4"><FormControl >
                    <TextField
                        label="Complemento"
                        inputProps={{ maxLength: 250 }}
                        placeholder="Informe o complemento"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'complemento')}
                        value={empresaSeller?.endereco?.complemento || ''}
                    />
                </FormControl></div>
            </div>

            <div className="row">
                <div className="col-sm-5 col-md-5 col-lg-5"> <FormControl >
                    <TextField
                        label="Bairro"
                        placeholder="Informe o Bairro"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'bairro')}
                        value={empresaSeller?.endereco?.bairro || ''}
                    /*  helperText={isFormInvalid && !empresaSeller?.endereco.bairro && 'Campo obrigatório'}
                     error={isFormInvalid && !empresaSeller?.endereco.bairro ? true : false} */
                    />
                </FormControl></div>
                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>

                        <InputLabel id="demo-simple-select-helper-label">Estado</InputLabel>
                        <Select
                            className="select"
                            variant="outlined"
                            value={empresaSeller?.endereco?.estado || 'selecione'}
                            label="Estado"
                            onChange={event => changesEndereco(event.target.value, 'estado')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem disabled={true} value={"selecione"}>
                                <em>Selecione o estado</em>
                            </MenuItem>

                            {estados.map(es =>
                                <MenuItem value={es}>{es}</MenuItem>
                            )}
                        </Select>

                        {/*  {isFormInvalid && !empresaSeller?.endereco?.estado &&
                            <FormHelperText>Campo obrigatório</FormHelperText>
                        } */}
                    </FormControl>
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                        <InputLabel id="demo-simple-select-helper-label">Cidade</InputLabel>
                        <Select
                            className="select"
                            variant="outlined"
                            value={empresaSeller?.endereco?.cidade.toUpperCase() || 'cidade'}
                            label="Cidade"
                            onChange={event => changesEndereco(event.target.value, 'cidade')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem disabled={true} value={"cidade"}>
                                <em>Selecione sua cidade</em>
                            </MenuItem>

                            {cidades.map(cd =>
                                <MenuItem value={cd.nome.toUpperCase()}>{cd?.nome}</MenuItem>
                            )}


                        </Select>
                        {/*  {isFormInvalid && !empresaSeller?.endereco?.cidade &&
                            <FormHelperText>Campo obrigatório</FormHelperText>
                        } */}
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                    <FormControl>
                        <TextField
                            label="URL Google Maps"
                            placeholder="Informe a URL"
                            type="text"
                            size="small"
                            inputProps={{ maxLength: 500 }}
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesEndereco(event.target.value, 'urlGoogleMaps')}
                            value={empresaSeller?.endereco?.urlGoogleMaps || ''}
                        /*  helperText={isFormInvalid && !empresaSeller?.endereco.urlGoogleMaps && 'Campo obrigatório'}
                         error={isFormInvalid && !empresaSeller?.endereco.urlGoogleMaps ? true : false} */
                        />
                    </FormControl></div>
                <div className="col-sm-3 col-md-3 col-lg-3"><FormControl >
                    <TextField
                        label="Telefone"
                        placeholder="00 00000-0000"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        inputProps={{ maxLength: "16" }}
                        onChange={event => changesTelefone(services.mask.phoneoucelularchange(event.target.value))}
                        value={services.mask.phoneoucelular(empresaSeller?.telefone?.ddd + empresaSeller?.telefone?.numero) || ''}
                    /*  helperText={isFormInvalid && !empresaSeller?.telefone.numero && 'Campo obrigatório'}
                     error={isFormInvalid && !empresaSeller?.telefone.numero ? true : false} */
                    />
                </FormControl></div>
                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl><InputLabel id="demo-simple-select-helper-label">Tipo</InputLabel>
                        <Select
                            className="select"
                            variant="outlined"
                            value={empresaSeller?.tipo || 'selecione'}
                            label="Estado"
                            onChange={event => changesDadosEmpresa(event.target.value, 'tipo')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem disabled={true} value={"selecione"}>
                                <em>Selecione o tipo</em>
                            </MenuItem>
                            <MenuItem value={"Industria"}>Indústria</MenuItem>
                            <MenuItem value={"Distribuidor"}>Distribuidor</MenuItem>
                            <MenuItem value={"Atacado"}>Atacado</MenuItem>

                        </Select>

                        {/*  {isFormInvalid && !empresaSeller?.tipo &&
                            <FormHelperText>Campo obrigatório</FormHelperText>
                        } */}
                    </FormControl>
                </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                <button className="col-sm-3 col-md-3 col-lg-3 buton-white-black-border" onClick={() => history.push('/home')}>CANCELAR</button>
                <button className="col-sm-3 col-md-3 col-lg-3 buton-green" onClick={submitEmpresaSeller}>SALVAR</button>
            </div>
        </div>
    )
}

export default PerfilDadosCadastraisSeller;